var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 66,
    viewBox: "0 0 48 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6099 60.8523C13.6099 61.6857 13.9573 62.4498 14.5823 63.0056L17.4305 65.3672C17.917 65.784 18.5421 65.9923 19.1671 65.9923H28.0587C28.6837 65.9923 29.3088 65.784 29.7953 65.3672L32.6435 63.0056C33.2685 62.4498 33.616 61.6856 33.616 60.8523V55.6424H13.4711L13.4706 60.8523H13.6099Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9726 0.141595C10.2752 1.32244 1.59186 9.86644 0.272025 20.5643C-0.770234 29.9418 3.53688 38.3473 10.5527 43.0709C12.4284 44.321 13.5395 46.3358 13.5395 48.5584V50.5034H33.6843V48.6277C33.6843 46.4744 34.726 44.3904 36.5325 43.1403C42.9232 38.9029 47.0913 31.6788 47.0913 23.4817C47.2303 9.65817 35.2131 -1.38663 20.9726 0.141595ZM33.6152 23.4818L21.8063 39.3198C20.7645 40.709 18.6106 39.7365 18.9581 38.0697L21.0422 27.8583H15.1374C13.8174 27.8583 13.0533 26.3301 13.8174 25.2883L25.6263 9.45027C26.6681 8.06109 28.822 9.03355 28.4745 10.7004L26.3905 20.9117H32.2952C33.6152 20.9112 34.3793 22.3702 33.6152 23.4818Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.d1c6a0e73e664c4af1aca0ed8e8b9864.svg";
export { ForwardRef as ReactComponent };